'use strict';

const callWebService = require('*/capency/email/serverActions/callWebService');
var capAddressConfig = [];
var urlCapEmailConfig = $('#url-cap-email-config').val();
const base = require('capencyBase/capency/email/function');

/// Call Ajax for get All configuration
$.ajax({
    url: urlCapEmailConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capAddressConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});


/**
* Handles the email data source for a given form configuration, including validation and autocomplete setup.
*
* @param {Object} configCurrentForm - Configuration object for the current form.
* @param {string} configCurrentForm.idForm - The ID of the form element.
* @param {boolean} configCurrentForm.formChild - Flag indicating if the email selector is a child of the form.
* @param {string} configCurrentForm.EmailID - The ID of the email input element.
* @param {string} configCurrentForm.firstName - The ID of the first name input element.
* @param {string} configCurrentForm.lastName - The ID of the last name input element.
*/
function dataSourceEmail(configCurrentForm) {
    var $formID = $('#' + configCurrentForm.idForm);
    let $emailSelector = configCurrentForm.formChild ? $formID.find('#' + configCurrentForm.EmailID) : $('#' + configCurrentForm.EmailID);
    var $firstNameSelector = $('#' + configCurrentForm.firstName);
    var $lastNameSelector = $('#' + configCurrentForm.lastName);

    var email = $emailSelector.val();
    var fname = $firstNameSelector.val();
    var lname = $lastNameSelector.val();

    callWebService.SearchMailCivWS(email, fname, lname).then(function (searchResulat) {
        if (searchResulat.returnCode && searchResulat.returnCode === 1) {
            $emailSelector.next('.invalid-feedback').empty().html(searchResulat.sMessage).show();
            $emailSelector.addClass('is-invalid');
            $formID.find(':submit').prop('disabled', true);
            if ($('.ui-autocomplete').length) {
                $emailSelector.autocomplete('destroy');
            }
        } else {
            $emailSelector.removeClass('is-invalid');
            $formID.find(':submit').prop('disabled', false);
            var finalDatasource = $.map(searchResulat.mail, function (item) {
                return {
                    label: item.sMail,
                    value: item.sMail
                };
            });

            if (finalDatasource.length > 0) {
                    $emailSelector.autocomplete({
                        create: function () {
                            $(this).attr('autocomplete', 'off');
                        },
                        minLength: 0,
                        autoFocus: true,
                        source: function (request, response) {
                            response(finalDatasource);
                        },
                        select: function (event, ui) {
                            let $this = $(this);
                            $this.next().html(ui.item.sMail);
                            $this.toggleClass('autocomplete-field-selected', true);
                            $this.next('.invalid-feedback').empty();
                            $this.data('isModified', true);
                        },
                        appendTo: '#' + configCurrentForm.idForm
                    }).focus(function () {
                        return false;
                    });
                $emailSelector.autocomplete('search', '');
            } else if ($emailSelector.autocomplete('instance')) {
                $emailSelector.autocomplete('destroy');
            }
        }
    });
}

/**
* Initiates the email processing flow based on the provided form configuration.
* If the form configuration contains an 'EmailID' property, it triggers the dataSourceEmail function.
*
* @param {Object} currentFormConfig - The current form configuration object.
* @property {string} currentFormConfig.EmailID - The email ID to be processed.
*/
function callProcessEmailFlow(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty('EmailID')) {
        dataSourceEmail(currentFormConfig);
    }
}

base.callProcessEmailFlow = callProcessEmailFlow;
module.exports = base;
